<!--
 * @Desc: 
 * @Author: lc
 * @Date: 2024-12-26 16:13:00
 * @LastEditors: lc
 * @LastEditTime: 2025-05-10 09:29:46
-->
<template>
  <div class="studylevel-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="addGoodCate"
                  type="success"
                  class="f-r">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           stripe
           :columns="columns1"
           ref="selection"
           :data="typelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加 弹层 -->
    <Drawer title="信息"
            v-model="showCreatTypeModal"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="cate"
            ref="addCate"
            :rules="cateValidate"
            action="javascript:void(0)">
        <FormItem label="名称"
                  prop="name">
          <Input v-model="cate.name"
                 placeholder />
        </FormItem>
        <FormItem label="描述">
          <Input type="textarea"
                 v-model="cate.describe"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <FormItem label="背景图">
          <upload-thumb v-model="cate.backthumb"
                        ref="uploadthumb3"
                        :defaultList="thumblist3"
                        :autoCropWidth="690"
                        :autoCropHeight="250"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:690*250,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="封面图">
          <upload-thumb v-model="cate.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="341"
                        :autoCropHeight="265"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:341*265,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="勋章样例图">
          <upload-thumb v-model="cate.xunzhang"
                        ref="uploadthumb1"
                        :defaultList="thumblist1"
                        :autoCropWidth="164"
                        :autoCropHeight="164"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:164*164,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="证书样例图">
          <upload-thumb v-model="cate.zhengshu"
                        ref="uploadthumb2"
                        :defaultList="thumblist2"
                        :autoCropWidth="212"
                        :autoCropHeight="156"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:212*156,大小不超过2M'"></upload-thumb>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showCreatTypeModal = false">取消</Button>
        <Button type="primary"
                :loading="tijiaoloading"
                @click="createType('addCate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>
  
  <script>
import UploadThumb from "../common/thumb";
import UploadThumb1 from "../common/thumb";
import UploadThumb2 from "../common/thumb";
import UploadThumb3 from "../common/thumb";
export default {
  name: "studylevel-list",
  data () {
    return {
      loading: true,
      dataloading: true,
      tijiaoloading: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      // 类别
      cate: {
        name: "", // 当前类别
        sort: "", // 排序
        heigher_name: "" // 上级类别
      },
      formItem: {},
      thumblist: [],
      thumblist1: [],
      thumblist2: [],
      // 类别 规则
      cateValidate: {
        name: [
          {
            required: true,
            message: "名称必须填写",
            trigger: "blur"
          }
        ]
      },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "名称",
          minWidth: 120,
          key: "name",
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  marginLeft: params.row.left + "px"
                }
              },
              params.row.name
            );
          }
        },
        {
          title: "描述",
          minWidth: 300,
          key: "describe",
        },
        {
          title: "排序",
          key: "sort",
          minWidth: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "InputNumber",
                {
                  props: {
                    min: 0,
                    value: params.row.sort,
                    size: "small",
                    number: true
                  },
                  on: {
                    "on-change": value => {
                      this.sort(params.row.id, value);
                    }
                  }
                },
                "排序"
              )
            ]);
          }
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('i-switch', {
                props: {
                  value: params.row.status == 0 ? true : false   //控制开关的打开或关闭状态，官网文档属性是value
                },
                on: {
                  'on-change': (value) => {
                    this.changeStatus(params.row.id, value)
                  }
                }
              }, '开关')
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          minWidth: 130,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.filelist(params.row.id);
                    }
                  }
                },
                "完成记录"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editType(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeType(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      typelist: [], //类别列表
      showCreatTypeModal: false,
      currentId: 0 // 编辑类别，当前类别id
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb,
    UploadThumb1,
    UploadThumb2,
    UploadThumb3
  },
  methods: {
    filelist: function (id) {
      this.$router.push(`/studylevellog/list/${id}`);
    },
    // 获取类别列表
    getTableList: function () {
      var self = this;
      var params = {
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.studylevel.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.typelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var params = {
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.studylevel.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.typelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 添加
    addGoodCate: function () {
      this.currentId = 0;
      this.tijiaoloading = false;
      this.cate = {
        name: "",
        describe: "",
        thumb: "",
        xunzhang: "",
        zhengshu: "",
      };
      this.thumblist = new Array();
      this.thumblist1 = new Array();
      this.thumblist2 = new Array();
      this.thumblist3 = new Array();
      this.showCreatTypeModal = true;
    },
    // 编辑类别
    editType: function (id) {
      this.currentId = id;
      this.showCreatTypeModal = true;
      this.tijiaoloading = false;
      this.thumblist = new Array();
      this.thumblist1 = new Array();
      this.thumblist2 = new Array();
      this.thumblist3 = new Array();
      this.$api.studylevel.detail({ id: id }).then(res => {
        if (res.code == 200) {
          this.cate.name = res.result.name;
          this.cate.sort = res.result.sort;
          this.cate.describe = res.result.describe;
          this.cate.thumb = res.result.thumb;
          if (this.cate.thumb != null && this.cate.thumb != "") {
            this.thumblist.push({
              name: this.cate.thumb,
              url: this.cate.thumb,
              status: "finished"
            });
          }
          if (res.result.xunzhang != null && res.result.xunzhang != "") {
            this.thumblist1.push({
              name: res.result.xunzhang,
              url: res.result.xunzhang,
              status: "finished"
            });
          }
          if (res.result.zhengshu != null && res.result.zhengshu != "") {
            this.thumblist2.push({
              name: res.result.zhengshu,
              url: res.result.zhengshu,
              status: "finished"
            });
          }
          if (res.result.backthumb != null && res.result.backthumb != "") {
            this.thumblist3.push({
              name: res.result.backthumb,
              url: res.result.backthumb,
              status: "finished"
            });
          }
        }
      });
    },
    // 提交新类别
    createType: function (name) {
      this.tijiaoloading = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.cate.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.cate.thumb = null;
          }
          if (this.$refs["uploadthumb1"].uploadList.length > 0) {
            this.cate.xunzhang = this.$refs["uploadthumb1"].uploadList[0].url;
          } else {
            this.cate.xunzhang = null;
          }
          if (this.$refs["uploadthumb2"].uploadList.length > 0) {
            this.cate.zhengshu = this.$refs["uploadthumb2"].uploadList[0].url;
          } else {
            this.cate.zhengshu = null;
          }
          if (this.$refs["uploadthumb3"].uploadList.length > 0) {
            this.cate.backthumb = this.$refs["uploadthumb3"].uploadList[0].url;
          } else {
            this.cate.backthumb = null;
          }
          let params = {
            thumb: this.cate.thumb,
            name: this.cate.name, // 分类名称
            describe: this.cate.describe,
            xunzhang: this.cate.xunzhang,
            zhengshu: this.cate.zhengshu,
            backthumb: this.cate.backthumb,
          };
          if (this.currentId == null || this.currentId == 0) {
            this.tijiaoloading = false;
            this.$api.studylevel.create(params).then(res => {
              if (res.code == 200) {
                this.showCreatTypeModal = false;
                this.getTableList();
              }
            });
          } else {
            params.id = this.currentId;
            this.$api.studylevel.edit(params).then(res => {
              this.tijiaoloading = false;
              if (res.code == 200) {
                this.showCreatTypeModal = false;
                this.getTableList();
              }
            });
          }
          this.tijiaoloading = false;
          this.$nextTick(() => {
            this.tijiaoloading = true;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.tijiaoloading = false;
          this.$nextTick(() => {
            this.tijiaoloading = true;
          });
        }
      });
      this.tijiaoloading = false;
    },
    sort: function (id, sort) {
      this.$api.studylevel.sort({ id: id, sort: sort }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.studylevel.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.renderTable(1);
        }
      });
    },
    // 删除
    removeType: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>是否确定删除该类别？</p>",
        onOk: () => {
          this.$api.studylevel
            .remove({
              id: id
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
  }
};
  </script>